import { useMemo } from 'react'
import { ISelectOption } from 'components/forms/Selects'
import { useEdiTransactionSetsWithSubtypesQuery } from '../../EdiSelfServiceOutbound/graphql/EdiTransactionSetsWithSubtypes'
import {
  encodeOptionValue,
  formatOptionLabel,
} from '../../EdiSelfServiceOutbound/hooks/useTransactionSets'

export const useTransactionSets = () => {
  const { data: transactionSetData } = useEdiTransactionSetsWithSubtypesQuery()

  // after we receieve the gql query result (containing valid transaction set + subtype pairs)
  // we need to update our list of select options
  const selectOptions: ISelectOption[] = useMemo(
    () =>
      transactionSetData?.ediTransactionSetsWithSubtypes?.map(item => {
        const label = formatOptionLabel(item)
        const value = encodeOptionValue(item.transactionSet, item.transactionSetSubtype)
        return { label, value }
      }) || [],
    [transactionSetData]
  )

  return {
    selectOptions,
  }
}
